import React from 'react'
import { Cohorts, RealestateMarketing, Occupancy, Maintenance, RealestateCrm } from 'components/Icons/Icons'
export const ONPERMISE_PROFESSIONAL_MINIMUM_PRICING = 0
export const ONPERMISE_PROFESSIONAL_MINIMUM_UNITSS = 0
export const ONPERMISE_ENTERPRISE_MINIMUM_PRICING = 450
export const PROPERTY_MANAGEMENT_CLOUD_MINIMUM_PRICING = 0 //standard
export const PROPERTY_MANAGEMENT_CLOUD_PROFESSIONAL_MINIMUM_PRICING = 0
export const PROPERTY_MANAGEMENT_CLOUD_ENTERPRISE_MINIMUM_PRICING = 450
export const REAL_ESTATE_CRM_CLOUD_MINIMUM_PRICING = 0 //standard
export const REAL_ESTATE_CRM_CLOUD_PROFESSIONAL_MINIMUM_PRICING = 0
export const REAL_ESTATE_CRM_CLOUD_ENTERPRISE_MINIMUM_PRICING = 450
export const REAL_ESTATE_MARKETING_CLOUD_MINIMUM_PRICING = 0 //standard
export const REAL_ESTATE_MARKETING_CLOUD_PROFESSIONAL_MINIMUM_PRICING = 0
export const REAL_ESTATE_MARKETING_CLOUD_ENTERPRISE_MINIMUM_PRICING = 450
export const MARKETING_CONTACTS_CLOUD_ENTERPRISE_MINIMUM_PRICING = 0
export const MARKETING_CONTACTS_CLOUD_MINIMUM_PRICING = 0
export const MARKETING_WEBSITE_CLOUD_ENTERPRISE_MINIMUM_PRICING = 0
export const MARKETING_WEBSITE_CLOUD_MINIMUM_PRICING = 0
export const MARKETING_APP_CLOUD_ENTERPRISE_MINIMUM_PRICING = 0
export const MARKETING_APP_CLOUD_MINIMUM_PRICING = 0
export const pricingLabels = {
    5: 'First 5 users/mo',
    50: '6 - 50',
    150: '51 - 150',
    500: '151 - 5000',
    501: '500+',
    1: 'First 1 unit/mo',
    2: '1-2 units',
    10: '2-10 units',
    100: '10-100 units',
    1000: '100 - 1000 units',
}
export const marketingPricing = {
    'marketing-automation-sequence': [
        [1000, 0.2],
        [5000, 0.18],
        [10000, 0.15],
        [Number.MAX_SAFE_INTEGER, 0.1],
    ],
    'real-estate-website-builder': [
        [100, 2.0],
        [500, 1.8],
        [1000, 1.5],
        [Number.MAX_SAFE_INTEGER, 1.2],
    ],
    'mobile-app-builder': [
        [100, 2.0],
        [500, 1.8],
        [1000, 1.5],
        [Number.MAX_SAFE_INTEGER, 1.2],
    ],
}

export const pricing = {
    'property-management-on-premise-standard': [
        [1, 0],
        [2, 0.45],
        [10, 0.225],
        [100, 0.075],
        [Number.MAX_SAFE_INTEGER, 0.025],
    ],
    'property-management-on-premise-enterprise': [
        [1, 0],
        [2, 0.45],
        [10, 0.45],
        [100, 0.09],
        [Number.MAX_SAFE_INTEGER, 0.025],
    ],
    'propertymanagementcloud-standard': [
        [10, 0], // First 10 units are free
        [100, 1.4], // From 11 to 100 units, cost is 1.4 per unit
        [500, 1.125], // From 101 to 500 units, cost is 1.125 per unit
        [1000, 0.75], // From 501 to 1000 units, cost is 0.75 per unit
        [Number.MAX_SAFE_INTEGER, 0.5], // Above 1000 units, cost is 0.5 per unit
    ],
    'propertymanagementcloud-professional': [
        [10, 4], // From 1 to 10 units, cost is 4.0 per unit
        [100, 3.45], // From 11 to 100 units, cost is 3.45 per unit
        [500, 2.225], // From 101 to 500 units, cost is 2.225 per unit
        [1000, 1.75], // From 501 to 1000 units, cost is 1.75 per unit
        [Number.MAX_SAFE_INTEGER, 1.25], // Above 1000 units, cost is 1.25 per unit
    ],
    'real-estate-crm-cloud-standard': [
        [1, 0], // First user is free
        [10, 49.0], // From 2 to 10 users, cost is 49.0 per user
        [50, 39.0], // From 11 to 50 users, cost is 39.0 per user
        [150, 25.0], // From 51 to 150 users, cost is 25.0 per user
        [500, 15.0], // From 151 to 500 users, cost is 15.0 per user
        [Number.MAX_SAFE_INTEGER, 10.0], //  Above 500 users, cost is 10.0 per user
    ],
    'real-estate-crm-cloud-professional': [
        [1, 70.0], // First user costs 70.0
        [10, 60.0], // From 2 to 10 users, cost is 60.0 per user
        [50, 50.5], // From 11 to 50 users, cost is 50.5 per user
        [100, 40.45], // From 51 to 100 users, cost is 40.45 per user
        [500, 30.4], // From 101 to 500 users, cost is 30.4 per user
        [Number.MAX_SAFE_INTEGER, 20.35], //   Above 500 users, cost is 20.35 per user
    ],
    'real-estate-marketing-cloud-standard': [
        [5, 0],
        [50, 49.0],
        [150, 20.45],
        [500, 10.4],
        [501, 8.35],
    ],
    'real-estate-marketing-cloud-professional': [
        [10, 70.0],
        [50, 50.5],
        [100, 40.45],
        [500, 30.4],
        [501, 20.35],
    ],
    'marketing-contacts-cloud-standard': [
        [1, 0],
        [1000, 0.2], // First 1000 contacts cost 0.2 per contact
        [5000, 0.18], // From 1001 to 5000 contacts, cost is 0.18 per contact
        [10000, 0.15], // From 5001 to 10000 contacts, cost is 0.15 per contact
        [50000, 0.1], // From 10001 to 50000 contacts, cost is 0.1 per contact
        [Number.MAX_SAFE_INTEGER, 0.05], // Above 50000 contacts, cost is 0.05 per contact
    ],
    'marketing-contacts-cloud-professional': [
        [1000, 0.18], // First 1000 contacts cost 0.18 per contact
        [5000, 0.15], // From 1001 to 5000 contacts, cost is 0.15 per contact
        [10000, 0.12], // From 5001 to 10000 contacts, cost is 0.12 per contact
        [50000, 0.08], // From 10001 to 50000 contacts, cost is 0.08 per contact
        [Number.MAX_SAFE_INTEGER, 0.03], // Above 50000 contacts, cost is 0.03 per contact
    ],
    'marketing-website-cloud-standard': [
        [1, 0],
        [100, 2], // First 100 users cost 2 per user
        [500, 1.8], // From 101 to 500 users, cost is 1.8 per user
        [1000, 1.5], // From 501 to 1000 users, cost is 1.5 per user
        [5000, 1], // From 1001 to 5000 users, cost is 1 per user
        [Number.MAX_SAFE_INTEGER, 0.5], // Above 5000 users, cost is 0.5 per user
    ],
    'marketing-website-cloud-professional': [
        [100, 1.8], // First 100 users cost 1.8 per user
        [500, 1.5], // From 101 to 500 users, cost is 1.5 per user
        [1000, 1.2], // From 501 to 1000 users, cost is 1.2 per user
        [5000, 0.8], // From 1001 to 5000 users, cost is 0.8 per user
        [Number.MAX_SAFE_INTEGER, 0.4], // Above 5000 users, cost is 0.4 per user
    ],
    'marketing-app-cloud-standard': [
        [1, 0],
        [100, 2], // First 100 users cost 2 per user
        [500, 1.8], // From 101 to 500 users, cost is 1.8 per user
        [1000, 1.5], // From 501 to 1000 users, cost is 1.5 per user
        [5000, 1], // From 1001 to 5000 users, cost is 1 per user
        [Number.MAX_SAFE_INTEGER, 0.5], // Above 5000 users, cost is 0.5 per user
    ],
    'marketing-app-cloud-professional': [
        [100, 1.8], // First 100 users cost 1.8 per user
        [500, 1.5], // From 101 to 500 users, cost is 1.5 per user
        [1000, 1.2], // From 501 to 1000 users, cost is 1.2 per user
        [5000, 0.8], // From 1001 to 5000 users, cost is 0.8 per user
        [Number.MAX_SAFE_INTEGER, 0.4], // Above 5000 users, cost is 0.4 per user
    ],
    'propertymanagementcloud-enterprise': [
        [1, 0],
        [2, 0.45],
        [10, 0.45],
        [100, 0.09],
        [Number.MAX_SAFE_INTEGER, 0.025],
    ],
    'real-estate-crm-cloud-enterprise': [
        [1, 0],
        [2, 0.45],
        [10, 0.45],
        [100, 0.09],
        [Number.MAX_SAFE_INTEGER, 0.025],
    ],
}

export type PricingOptionType =
    | 'property-management-on-premise-standard'
    | 'on-premise-professional'
    | 'property-management-on-premise-enterprise'
    | 'propertymanagementcloud-standard'
    | 'propertymanagementcloud-professional'
    | 'propertymanagementcloud-enterprise'
    | 'real-estate-crm-cloud-standard'
    | 'real-estate-crm-cloud-professional'
    | 'real-estate-crm-cloud-enterprise'
    | 'real-estate-marketing-cloud-standard'
    | 'real-estate-marketing-cloud-professional'
    | 'real-estate-marketing-cloud-enterprise'
    | 'marketing-contacts-cloud-standard'
    | 'marketing-contacts-cloud-professional'
    | 'marketing-contacts-cloud-enterprise'
    | 'marketing-website-cloud-standard'
    | 'marketing-website-cloud-professional'
    | 'marketing-website-cloud-enterprise'
    | 'marketing-app-cloud-standard'
    | 'marketing-app-cloud-professional'
    | 'marketing-app-cloud-enterprise'

export const features = {
    Platform: [
        { title: 'Occupancy & Accounting', icon: <Occupancy className="w-4" /> },
        { title: 'Real Estate Marketing', icon: <RealestateMarketing className="w-4" /> },
        { title: 'Cohorts & Portal', icon: <Cohorts className="w-4" /> },
        { title: 'Real estate Crm', icon: <RealestateCrm className="w-4" /> },
        { title: 'Maintenance', icon: <Maintenance className="w-4" /> },
    ],
    'Platform features': [
        { title: 'Dashboards' },
        { title: 'Event autocapture' },
        { title: 'Annotations' },
        { title: 'API' },
        { title: 'Apps' },
        { title: 'Data I/O' },
    ],
    'Advanced features': [
        { title: 'Task Management' },
        { title: 'Group PropertyManagement' },
        { title: 'Websites Suite' },
        { title: 'Multiple projects' },
    ],
    Collaboration: [
        { title: 'User permissions' },
        { title: 'Dashboard collaboration tools' },
        { title: 'Team unit management tools' },
    ],
    'Account & support': [
        { title: 'Team training' },
        { title: 'Dashboard configuration support' },
        { title: 'Monitoring setup support' },
        { title: 'Infrastructure management pairing' },
        { title: 'SLA w/ downtime developer pairing' },
    ],
    'Ops & security': [
        { title: 'Project permissions' },
        { title: 'SSO, SAML' },
        { title: 'Configurable backups' },
        { title: 'Instance monitoring' },
    ],
    Support: [
        { title: 'Team training' },
        { title: 'Dashboard configuration support' },
        { title: 'Dedicated Slack channel' },
    ],
    'Advanced security': [{ title: 'Project permissions' }, { title: 'SSO, SAML' }],
    Benefits: [{ title: 'Hosted by iCloudReady' }, { title: 'Automatic upgrades' }, { title: 'Support Slack support' }],
}

export const defaultAvailablePlans = [
    {
        key: 'standard-20230117',
        name: 'Standard',
        description:
            'Your portfolio is taking off and you’re ready to up your game. Get the essentials to automate your day-to-day and get your business running from a central platform.',
        is_free: false,
        products: [
            {
                type: 'units',
                name: 'Property management + tenant portal',
                description: 'Accounting, occupancy, maintenance + more',
                price_description: null,
                up_to_limit: 100,
                feature_groups: [
                    {
                        group: 'property_management',
                        name: 'Property management suite',
                        features: [
                            {
                                key: 'dashboards',
                                name: 'Dashboards',
                                description:
                                    'Save accounting, occupancy, and other insights for easy reference by your whole team.',
                                unit: null,
                                limit: null,
                                note: null,
                                group: 'property_management',
                            },
                            {
                                key: 'occupancy',
                                name: 'Occupancy',
                                description: 'Visualize user dropoff between a sequence of units.',
                                unit: null,
                                limit: null,
                                note: null,
                                group: 'property_management',
                            },
                            {
                                key: 'graphs_accounting',
                                name: 'Rental accounting & reporting',
                                description: 'Plot any number of units or actions over time.',
                                unit: null,
                                limit: null,
                                note: null,
                                group: 'property_management',
                            },
                            {
                                key: 'maintenance',
                                name: 'Maintenance',
                                description:
                                    'Limited maintenance excludes: customizing path insights by setting the maximum number of maintenance, number of people on each path, how path names appear',
                                unit: null,
                                limit: null,
                                note: 'Limited',
                                group: 'property_management',
                            },
                        ],
                    },
                ],
                image_url: null,
                // tiers: null,
                tiers: [
                    {
                        flat_amount_usd: '0',
                        unit_amount_usd: '0',
                        up_to: 10,
                        current_amount_usd: '0.00',
                        current_usage: 0,
                        projected_usage: null,
                        projected_amount_usd: null,
                    },
                    {
                        flat_amount_usd: '0',
                        unit_amount_usd: '1.4',
                        up_to: 100,
                        current_amount_usd: '0.00',
                        current_usage: 0,
                        projected_usage: null,
                        projected_amount_usd: null,
                    },
                    {
                        flat_amount_usd: '0',
                        unit_amount_usd: '1.125',
                        up_to: 500,
                        current_amount_usd: '0.00',
                        current_usage: 0,
                        projected_usage: null,
                        projected_amount_usd: null,
                    },
                    {
                        flat_amount_usd: '0',
                        unit_amount_usd: '0.75',
                        up_to: 1000,
                        current_amount_usd: '0.00',
                        current_usage: 0,
                        projected_usage: null,
                        projected_amount_usd: null,
                    },
                    {
                        flat_amount_usd: '0',
                        unit_amount_usd: '0.5',
                        up_to: null,
                        current_amount_usd: '0.00',
                        current_usage: 0,
                        projected_usage: null,
                        projected_amount_usd: null,
                    },
                ],
                tiered: true,
                unit: 'unit',
                unit_amount_usd: null,
            },
            {
                type: 'users',
                name: 'Real estate crm',
                description:
                    'Searchable users of people using your app or website with console logs and behavioral bucketing.',
                price_description: null,
                up_to_limit: 50,
                feature_groups: [
                    {
                        group: 'realestate_crm',
                        name: 'Real estate crm',
                        features: [
                            {
                                key: 'users_playlists',
                                name: 'Recording playlists',
                                description:
                                    'Create playlists of certain Real estate crms to easily find and watch them again in the future.',
                                unit: 'playlists',
                                limit: 5,
                                note: null,
                                group: 'realestate_crm',
                            },
                            {
                                key: 'console_logs',
                                name: 'Console logs',
                                description: "Diagnose issues by inspecting errors in the user's network console",
                                unit: null,
                                limit: null,
                                note: null,
                                group: 'realestate_crm',
                            },
                        ],
                    },
                ],
                image_url: null,
                tiered: true,
                unit: 'user',
                unit_amount_usd: null,
                tiers: [
                    {
                        flat_amount_usd: '0',
                        unit_amount_usd: '0',
                        up_to: 5,
                        current_amount_usd: '0.00',
                        current_usage: 0,
                        projected_usage: null,
                        projected_amount_usd: null,
                    },
                    {
                        flat_amount_usd: '0',
                        unit_amount_usd: '49.0',
                        up_to: 50,
                        current_amount_usd: '0.00',
                        current_usage: 0,
                        projected_usage: null,
                        projected_amount_usd: null,
                    },
                    {
                        flat_amount_usd: '0',
                        unit_amount_usd: '20.45',
                        up_to: 150,
                        current_amount_usd: '0.00',
                        current_usage: 0,
                        projected_usage: null,
                        projected_amount_usd: null,
                    },
                    {
                        flat_amount_usd: '0',
                        unit_amount_usd: '10.4',
                        up_to: 500,
                        current_amount_usd: '0.00',
                        current_usage: 0,
                        projected_usage: null,
                        projected_amount_usd: null,
                    },
                    {
                        flat_amount_usd: '0',
                        unit_amount_usd: '8.35',
                        up_to: null,
                        current_amount_usd: '0.00',
                        current_usage: 0,
                        projected_usage: null,
                        projected_amount_usd: null,
                    },
                ],
            },
            {
                type: 'base',
                name: 'Base product',
                description: 'Base product including core features and an optional monthly fee',
                price_description: null,
                up_to_limit: null,
                feature_groups: [
                    {
                        group: 'realestate_marketing',
                        name: 'Real estate marketing',
                        features: [
                            {
                                key: 'boolean_flags',
                                name: 'Boolean real estate marketing',
                                description: 'Turn features on and off for specific users.',
                                unit: null,
                                limit: null,
                                note: null,
                                group: 'realestate_marketing',
                            },
                        ],
                    },
                    {
                        group: 'integrations',
                        name: 'Integrations',
                        features: [
                            {
                                key: 'zapier',
                                name: 'Zapier',
                                description:
                                    'Zapier lets you connect iCloudReady with thousands of the most popular apps, so you can automate your work and have more time for what matters most\u2014no code required.',
                                unit: null,
                                limit: null,
                                note: null,
                                group: 'integrations',
                            },
                            {
                                key: 'marketplace',
                                name: 'Marketplace',
                                description: 'Connect your data to iCloudReady with 50+ integrations.',
                                unit: null,
                                limit: null,
                                note: null,
                                group: 'integrations',
                            },
                            {
                                key: 'slack_integration',
                                name: 'Slack',
                                description: 'Get notified about new actions in Slack.',
                                unit: null,
                                limit: null,
                                note: null,
                                group: 'integrations',
                            },
                            {
                                key: 'microsoft_teams_integration',
                                name: 'Microsoft Teams',
                                description: 'Get notified about new actions in Microsoft Teams.',
                                unit: null,
                                limit: null,
                                note: null,
                                group: 'integrations',
                            },
                            {
                                key: 'discord_integration',
                                name: 'Discord',
                                description: 'Get notified about new actions in Discord.',
                                unit: null,
                                limit: null,
                                note: null,
                                group: 'integrations',
                            },
                        ],
                    },
                    {
                        group: 'platform',
                        name: 'Platform',
                        features: [
                            {
                                key: 'organizations_projects',
                                name: 'Projects',
                                description:
                                    'Create silos of data within iCloudReady. All data belongs to a single project and all queries are project-specific.',
                                unit: 'project',
                                limit: 1,
                                note: null,
                                group: 'platform',
                            },
                            {
                                key: 'google_login',
                                name: 'Google oAuth',
                                description: "Use Google's oAuth to log in to iCloudReady.",
                                unit: null,
                                limit: null,
                                note: null,
                                group: 'platform',
                            },
                            {
                                key: 'tracked_users',
                                name: 'Tracked users',
                                description: 'Track users across devices and sessions.',
                                unit: null,
                                limit: null,
                                note: 'Unlimited',
                                group: 'platform',
                            },
                            {
                                key: 'data_portal',
                                name: 'Data portal',
                                description: 'Keep a historical record of your data.',
                                unit: 'year',
                                limit: 1,
                                note: null,
                                group: 'platform',
                            },
                            {
                                key: 'team_members',
                                name: 'Team members',
                                description: "iCloudReady doesn't charge per seat - add your entire team!",
                                unit: null,
                                limit: null,
                                note: 'Unlimited',
                                group: 'platform',
                            },
                            {
                                key: 'api_access',
                                name: 'API access',
                                description: 'Access your data via our developer-friendly API.',
                                unit: null,
                                limit: null,
                                note: null,
                                group: 'platform',
                            },
                        ],
                    },
                    {
                        group: 'support',
                        name: 'Support',
                        features: [
                            {
                                key: 'support_support',
                                name: 'Slack (support)',
                                description:
                                    'Get help from the iCloudReady support in our iCloudReady Users Slack group.',
                                unit: null,
                                limit: null,
                                note: null,
                                group: 'support',
                            },
                            {
                                key: 'terms_and_conditions',
                                name: 'Terms and conditions',
                                description: 'Terms and conditions',
                                unit: null,
                                limit: null,
                                note: 'Standard',
                                group: 'support',
                            },
                        ],
                    },
                ],
                image_url: null,
                tiers: null,
                tiered: false,
                unit: null,
                unit_amount_usd: null,
            },
        ],
    },
    {
        key: 'professional-20230117',
        name: 'Professional',
        description:
            'You’re growing and need the right tools to take you there. Grow from Essential with additional features, support, and performance insights to help you optimize.',
        is_free: false,
        products: [
            {
                type: 'units',
                name: 'Property management + tenant portal',
                description: 'Accounting, occupancy, maintenance + more',
                price_description: null,
                up_to_limit: null,
                feature_groups: [
                    {
                        group: 'property_management',
                        name: 'Property management suite',
                        features: [
                            {
                                key: 'dashboards',
                                name: 'Dashboards',
                                description:
                                    'Save accounting, occupancy, and other insights for easy reference by your whole team.',
                                unit: null,
                                limit: null,
                                note: null,
                                group: 'property_management',
                            },
                            {
                                key: 'occupancy',
                                name: 'Occupancy',
                                description: 'Visualize user dropoff between a sequence of units.',
                                unit: null,
                                limit: null,
                                note: null,
                                group: 'property_management',
                            },
                            {
                                key: 'graphs_accounting',
                                name: 'Rental accounting & reporting',
                                description: 'Plot any number of units or actions over time.',
                                unit: null,
                                limit: null,
                                note: null,
                                group: 'property_management',
                            },
                            {
                                key: 'maintenance',
                                name: 'Maintenance',
                                description:
                                    'Limited maintenance excludes: customizing path insights by setting the maximum number of maintenance, number of people on each path, how path names appear',
                                unit: null,
                                limit: null,
                                note: null,
                                group: 'property_management',
                            },
                            {
                                key: 'subscriptions',
                                name: 'Insight & dashboard subscriptions',
                                description:
                                    'Create a subscription for any insight or dashboard in iCloudReady to receive regular reports with their updates.',
                                unit: null,
                                limit: null,
                                note: null,
                                group: 'property_management',
                            },
                            {
                                key: 'maintenance_advanced',
                                name: 'Advanced maintenance',
                                description:
                                    'Customize your path insights by setting the maximum number of maintenance, number of people on each path, and how path names should appear.',
                                unit: null,
                                limit: null,
                                note: null,
                                group: 'property_management',
                            },
                            {
                                key: 'dashboard_permissioning',
                                name: 'Dashboard permissions',
                                description:
                                    'Restrict access to dashboards within the organization to only those who need it.',
                                unit: null,
                                limit: null,
                                note: null,
                                group: 'property_management',
                            },
                            {
                                key: 'dashboard_collaboration',
                                name: 'Dashboard permissions',
                                description:
                                    'Restrict access to data within the organization to only those who need it.',
                                unit: null,
                                limit: null,
                                note: null,
                                group: 'property_management',
                            },
                            {
                                key: 'ingestion_taxonomy',
                                name: 'Ingestion taxonomy',
                                description: 'Ingestion taxonomy',
                                unit: null,
                                limit: null,
                                note: null,
                                group: 'property_management',
                            },
                            {
                                key: 'task_analysis',
                                name: 'Task management',
                                description:
                                    'Automatically highlight significant factors that affect the conversion rate of users within a funnel.',
                                unit: null,
                                limit: null,
                                note: null,
                                group: 'property_management',
                            },
                            {
                                key: 'group_propertymanagement',
                                name: 'Stakeholder management',
                                description:
                                    'Associate units with a group - such as a company, support, or project - and analyze them in that context.',
                                unit: null,
                                limit: null,
                                note: null,
                                group: 'property_management',
                            },
                            {
                                key: 'tagging',
                                name: 'Dashboard tags',
                                description: 'Organize dashboards with tags.',
                                unit: null,
                                limit: null,
                                note: null,
                                group: 'property_management',
                            },
                            {
                                key: 'behavioral_cohort_filtering',
                                name: 'Rentpayment cohorts',
                                description:
                                    'Group users based on their long term behavior, such as whether they frequently performed an unit, or have recently stopped performing an unit.',
                                unit: null,
                                limit: null,
                                note: null,
                                group: 'property_management',
                            },
                        ],
                    },
                ],
                image_url: null,
                tiers: [
                    {
                        flat_amount_usd: '0',
                        unit_amount_usd: '4',
                        up_to: 10,
                        current_amount_usd: '0.00',
                        current_usage: 0,
                        projected_usage: null,
                        projected_amount_usd: null,
                    },
                    {
                        flat_amount_usd: '0',
                        unit_amount_usd: '3.45',
                        up_to: 100,
                        current_amount_usd: '0.00',
                        current_usage: 0,
                        projected_usage: null,
                        projected_amount_usd: null,
                    },
                    {
                        flat_amount_usd: '0',
                        unit_amount_usd: '2.22',
                        up_to: 500,
                        current_amount_usd: '0.00',
                        current_usage: 0,
                        projected_usage: null,
                        projected_amount_usd: null,
                    },
                    {
                        flat_amount_usd: '0',
                        unit_amount_usd: '1.75',
                        up_to: 1000,
                        current_amount_usd: '0.00',
                        current_usage: 0,
                        projected_usage: null,
                        projected_amount_usd: null,
                    },
                    {
                        flat_amount_usd: '0',
                        unit_amount_usd: '1.25',
                        up_to: null,
                        current_amount_usd: '0.00',
                        current_usage: 0,
                        projected_usage: null,
                        projected_amount_usd: null,
                    },
                ],
                tiered: true,
                unit: 'unit',
                unit_amount_usd: null,
            },
            {
                type: 'users',
                name: 'Real estate crm',
                description:
                    'Searchable users of people using your app or website with console logs and behavioral bucketing.',
                price_description: null,
                up_to_limit: null,
                feature_groups: [
                    {
                        group: 'realestate_crm',
                        name: 'Real estate crm',
                        features: [
                            {
                                key: 'console_logs',
                                name: 'Console logs',
                                description: "Diagnose issues by inspecting errors in the user's network console",
                                unit: null,
                                limit: null,
                                note: null,
                                group: 'realestate_crm',
                            },
                            {
                                key: 'users_playlists',
                                name: 'Recording playlists',
                                description:
                                    'Create playlists of certain Real estate crms to easily find and watch them again in the future.',
                                unit: null,
                                limit: null,
                                note: null,
                                group: 'realestate_crm',
                            },
                            {
                                key: 'users_performance',
                                name: 'Network performance on users',
                                description:
                                    "See your end-user's network performance and information alongside Real estate crms.",
                                unit: null,
                                limit: null,
                                note: null,
                                group: 'realestate_crm',
                            },
                            {
                                key: 'users_file_export',
                                name: 'Recordings file export',
                                description: 'Save Real estate crms as a file to your local filesystem.',
                                unit: null,
                                limit: null,
                                note: null,
                                group: 'realestate_crm',
                            },
                        ],
                    },
                ],
                image_url: null,
                tiers: [
                    {
                        flat_amount_usd: '0',
                        unit_amount_usd: '70.0',
                        up_to: 10,
                        current_amount_usd: '0.00',
                        current_usage: 0,
                        projected_usage: null,
                        projected_amount_usd: null,
                    },
                    {
                        flat_amount_usd: '0',
                        unit_amount_usd: '50.5',
                        up_to: 50,
                        current_amount_usd: '0.00',
                        current_usage: 0,
                        projected_usage: null,
                        projected_amount_usd: null,
                    },
                    {
                        flat_amount_usd: '0',
                        unit_amount_usd: '40.45',
                        up_to: 100,
                        current_amount_usd: '0.00',
                        current_usage: 0,
                        projected_usage: null,
                        projected_amount_usd: null,
                    },
                    {
                        flat_amount_usd: '0',
                        unit_amount_usd: '30.4',
                        up_to: 500,
                        current_amount_usd: '0.00',
                        current_usage: 0,
                        projected_usage: null,
                        projected_amount_usd: null,
                    },
                    {
                        flat_amount_usd: '0',
                        unit_amount_usd: '20.35',
                        up_to: null,
                        current_amount_usd: '0.00',
                        current_usage: 0,
                        projected_usage: null,
                        projected_amount_usd: null,
                    },
                ],
                tiered: true,
                unit: 'user',
                unit_amount_usd: null,
            },
            {
                type: 'base',
                name: 'Base product',
                description: 'Base product including core features and an optional monthly fee',
                price_description: null,
                up_to_limit: null,
                feature_groups: [
                    {
                        group: 'realestate_marketing',
                        name: 'Real estate marketing',
                        features: [
                            {
                                key: 'boolean_flags',
                                name: 'Boolean real estate marketing',
                                description: 'Turn features on and off for specific users.',
                                unit: null,
                                limit: null,
                                note: null,
                                group: 'realestate_marketing',
                            },
                            {
                                key: 'multivariate_flags',
                                name: 'Multivariate real estate marketing',
                                description:
                                    'Create three or more variants of a feature flag to test or release different versions of a feature.',
                                unit: null,
                                limit: null,
                                note: null,
                                group: 'realestate_marketing',
                            },
                        ],
                    },
                    {
                        group: 'websites',
                        name: 'Websites',
                        features: [
                            {
                                key: 'websites',
                                name: 'Websites',
                                description:
                                    'Test changes to your product and evaluate the impacts those changes make.',
                                unit: null,
                                limit: null,
                                note: null,
                                group: 'websites',
                            },
                        ],
                    },
                    {
                        group: 'integrations',
                        name: 'Integrations',
                        features: [
                            {
                                key: 'zapier',
                                name: 'Zapier',
                                description:
                                    'Zapier lets you connect iCloudReady with thousands of the most popular apps, so you can automate your work and have more time for what matters most\u2014no code required.',
                                unit: null,
                                limit: null,
                                note: null,
                                group: 'integrations',
                            },
                            {
                                key: 'slack_integration',
                                name: 'Slack',
                                description: 'Get notified about new actions in Slack.',
                                unit: null,
                                limit: null,
                                note: null,
                                group: 'integrations',
                            },
                            {
                                key: 'microsoft_teams_integration',
                                name: 'Microsoft Teams',
                                description: 'Get notified about new actions in Microsoft Teams.',
                                unit: null,
                                limit: null,
                                note: null,
                                group: 'integrations',
                            },
                            {
                                key: 'discord_integration',
                                name: 'Discord',
                                description: 'Get notified about new actions in Discord.',
                                unit: null,
                                limit: null,
                                note: null,
                                group: 'integrations',
                            },
                            {
                                key: 'marketplace',
                                name: 'Marketplace',
                                description: 'Connect your data to iCloudReady with 50+ integrations.',
                                unit: null,
                                limit: null,
                                note: null,
                                group: 'integrations',
                            },
                            {
                                key: 'app_metrics',
                                name: 'App metrics',
                                description: 'Get metrics on your apps to see their usage, reliability, and more.',
                                unit: null,
                                limit: null,
                                note: null,
                                group: 'integrations',
                            },
                        ],
                    },
                    {
                        group: 'platform',
                        name: 'Platform',
                        features: [
                            {
                                key: 'tracked_users',
                                name: 'Tracked users',
                                description: 'Track users across devices and sessions.',
                                unit: null,
                                limit: null,
                                note: 'Unlimited',
                                group: 'platform',
                            },
                            {
                                key: 'data_portal',
                                name: 'Data portal',
                                description: 'Keep a historical record of your data.',
                                unit: null,
                                limit: null,
                                note: '7 years',
                                group: 'platform',
                            },
                            {
                                key: 'team_members',
                                name: 'Team members',
                                description: "iCloudReady doesn't charge per seat - add your entire team!",
                                unit: null,
                                limit: null,
                                note: 'Unlimited',
                                group: 'platform',
                            },
                            {
                                key: 'organizations_projects',
                                name: 'Projects',
                                description:
                                    'Create silos of data within iCloudReady. All data belongs to a single project and all queries are project-specific.',
                                unit: null,
                                limit: null,
                                note: 'Unlimited',
                                group: 'platform',
                            },
                            {
                                key: 'api_access',
                                name: 'API access',
                                description: 'Access your data via our developer-friendly API.',
                                unit: null,
                                limit: null,
                                note: null,
                                group: 'platform',
                            },
                            {
                                key: 'google_login',
                                name: 'Google oAuth',
                                description: "Use Google's oAuth to log in to iCloudReady.",
                                unit: null,
                                limit: null,
                                note: null,
                                group: 'platform',
                            },
                            {
                                key: 'project_based_permissioning',
                                name: 'Project permissions',
                                description:
                                    'Restrict access to data within the organization to only those who need it.',
                                unit: null,
                                limit: null,
                                note: null,
                                group: 'platform',
                            },
                            {
                                key: 'sso_enforcement',
                                name: 'SSO',
                                description:
                                    'Allow users to sign up and log in to your iCloudReady account with your specified SSO provider.',
                                unit: null,
                                limit: null,
                                note: null,
                                group: 'platform',
                            },
                        ],
                    },
                    {
                        group: 'support',
                        name: 'Support',
                        features: [
                            {
                                key: 'support_support',
                                name: 'Slack (support)',
                                description:
                                    'Get help from the iCloudReady support in our iCloudReady Users Slack group.',
                                unit: null,
                                limit: null,
                                note: null,
                                group: 'support',
                            },
                            {
                                key: 'dedicated_support',
                                name: 'Slack (dedicated channel)',
                                description:
                                    'Get help firectly from our support team in a dedicated Slack channel shared between you and the iCloudReady team.',
                                unit: null,
                                limit: null,
                                note: '$2k/month spend or above',
                                group: 'support',
                            },
                            {
                                key: 'email_support',
                                name: 'Email',
                                description: 'Get help from our support team via email.',
                                unit: null,
                                limit: null,
                                note: null,
                                group: 'support',
                            },
                            {
                                key: 'terms_and_conditions',
                                name: 'Terms and conditions',
                                description: 'Terms and conditions',
                                unit: null,
                                limit: null,
                                note: 'Standard',
                                group: 'support',
                            },
                            {
                                key: 'security_assessment',
                                name: 'Security assessment',
                                description: 'Security assessment',
                                unit: null,
                                limit: null,
                                note: null,
                                group: 'support',
                            },
                        ],
                    },
                ],
                image_url: null,
                tiers: null,
                tiered: false,
                unit: null,
                unit_amount_usd: null,
            },
        ],
    },
]
